<div class="modal-header">
    <h4 class="modal-title">
        <i data-feather="plus"></i> {{data.dialogTitle}} - ({{calibrationDevice.deliveryCode}}) Teslimat Numarası
    </h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body calibration-modal">
    <div class="row">

        <div class="col-xl-12 col-md-12 col-sm-12">
            <h4 class="card-title">Firma Adı</h4>
            <div class="card shadow-none bg-transparent border-success">
                <div class="card-body">
                    <div class="row">
                        <div class="col-xl-7 col-md-3 col-sm-12">
                            {{ calibrationDevice.company?.companyName }}
                        </div>

                        <div class="col-xl-auto col-md-3 col-sm-12"><strong>Telefon:</strong></div>
                        <div class="col-xl-1 col-md-3 col-sm-12">
                            {{ calibrationDevice.company?.phoneNumber }}
                        </div>

                        <div class="col-xl-auto col-md-3 col-sm-12"><strong>Teklif No:</strong></div>
                        <div class="col-xl-1 col-md-3 col-sm-12">
                            {{ calibrationDevice?.no }}
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="col-xl-4 col-md-12 col-sm-12">
            <h4 class="card-title">Cihaz Bilgileri</h4>

            <div class="card shadow-none bg-transparent border-info">
                <div class="card-header">
                    <button type="button" class="btn btn-icon btn-warning"
                        (click)="updateDeviceModal(calibrationDevice.deviceId)">
                        <i data-feather="edit"></i>
                    </button>
                </div>
                <div class="card-body">
                    <p><strong>Cihaz Adı:</strong> {{calibrationDevice.deviceName}}</p>
                    <div class="row">
                        <div class="col-xl-6 col-md-6 col-sm-12">
                            <div class="d-flex justify-content-between">
                                <strong>Seri No:</strong>
                                <span>{{ calibrationDevice.seriNo }}</span>
                            </div>
                            <div class="d-flex justify-content-between">
                                <strong>Tür:</strong>
                                <span>{{ calibrationDevice.typeName }}</span>
                            </div>
                            <div class="d-flex justify-content-between">
                                <strong>Yer:</strong>
                                <span>{{ calibrationDevice.place }}</span>
                            </div>
                            <div class="d-flex justify-content-between">
                                <strong>Cih. Kod:</strong>
                                <span>{{ calibrationDevice.deviceCode }}</span>
                            </div>
                        </div>
                        <div class="col-xl-6 col-md-6 col-sm-12">
                            <div class="d-flex justify-content-between">
                                <strong>Marka:</strong>
                                <span>{{ calibrationDevice.brandName }} - {{ calibrationDevice.modelName
                                    }}</span>
                            </div>
                            <div class="d-flex justify-content-between">
                                <strong>Envanter No:</strong>
                                <span>{{ calibrationDevice.inventoryNumber }}</span>
                            </div>
                            <div class="d-flex justify-content-between">
                                <strong>Çözünürlük:</strong>
                                <span>{{ calibrationDevice.resolution }}</span>
                            </div>
                            <div class="d-flex justify-content-between">
                                <strong>Referans:</strong>
                                <span>{{ calibrationDevice.referenceMin }}
                                    {{calibrationDevice.referenceUnitType}} -
                                    {{calibrationDevice.referenceMax}}
                                    {{calibrationDevice.referenceUnitType}} </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-xl-8 col-md-12 col-sm-12">
            <h4 class="card-title">Kalibrasyon Bilgileri</h4>

            <div class="card shadow-none bg-transparent border-warning ">
                <div class="p-50">

                    <div class="row">
                        <div class="col-xl-auto col-md-6 col-sm-12"><strong>Srtf Firması</strong>
                        </div>
                        <div class="col-xl-10 col-md-6 col-sm-12">
                            <input type="text" class="form-control" id="basicInput" readonly="true"
                                placeholder="Enter email" [(ngModel)]="calibrationDevice.certficateCompany" />
                        </div>
                    </div>

                    <div class="row mt-1">

                        <div class="col-xl-auto col-md-3 col-sm-12"><strong>Ortam Şartı <br></strong></div>
                        <div class="col-xl-3 col-md-9 col-sm-12">
                            <ng-select [items]="environmentalContent" [(ngModel)]="enviromentalContentId"
                                placeholder="Çevre şartı seç" bindValue="id" bindLabel="typeName"
                                #environmental="ngModel" required>
                                <ng-template ng-header-tmp>
                                    <button
                                        class="add-new-customer btn btn-flat-success cursor-pointer rounded-0 text-left p-50 w-100"
                                        (click)="showEnviromenetConditionDialog(); select.blur(); select.close()">
                                        <i data-feather="plus"></i>
                                        <span class="align-middle ml-25">Yeni</span>
                                    </button>
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                    <h6 class="mb-1">{{ item.deviceName }}</h6>
                                    <div class="card-subtitle mb-2">
                                        <p *ngFor="let environmental of item.enviromentalContent">
                                            {{ environmental.name }}, {{ environmental.start }}, {{
                                            environmental.end }}
                                        </p>
                                        {{ item.typeName }}
                                    </div>
                                </ng-template>
                            </ng-select>
                            <div class="text-danger mt-1" *ngIf="environmental.invalid && environmental.touched">
                                Zorunlu Alan
                            </div>
                        </div>

                        <div class="col-xl-1-5 col-md-3 col-sm-12"><strong>Kal. Tarihi</strong>
                        </div>
                        <div class="col-xl-2 col-md-9 col-sm-12">
                            <ng2-flatpickr [config]="dateTimeStartOptions" [(ngModel)]="date"></ng2-flatpickr>
                        </div>

                        <div class="col-xl-auto col-md-3 col-sm-12"><strong>Akra. Kuruluşu</strong>
                        </div>
                        <div class="col-xl-2 col-md-9 col-sm-12">
                            <ng-select [items]="akradetionOrganization" [(ngModel)]="selectedAcradtionOrganizationId"
                                placeholder="Akradite Kurumunu Seç" bindLabel="name" bindValue="id"
                                #akreditation="ngModel" required>
                            </ng-select>
                            <div class="text-danger mt-1" *ngIf="akreditation.invalid && akreditation.touched">
                                Zorunlu Alan
                            </div>
                        </div>
                    </div>

                    <div class="row mt-1">

                        <div class="col-xl-auto col-md-3 col-sm-12"><strong>Kal. Method</strong>
                        </div>
                        <div class="col-xl-3 col-md-9 col-sm-12">
                            <ng-select [items]="kindProcedures" [(ngModel)]="selectProcedureId"
                                placeholder="Kalibrasyon methodu seç" bindValue="id" bindLabel="name"
                                #procedure="ngModel" required (change)="onProcedureChange()">
                            </ng-select>
                            <div class="text-danger mt-1" *ngIf="procedure.invalid && procedure.touched">
                                Zorunlu Alan
                            </div>
                        </div>

                        <div class="col-xl-1-5 col-md-3 col-sm-12"><strong>Kal. Yapan</strong>
                        </div>
                        <div class="col-xl-2 col-md-9 col-sm-12">
                            <ng-select [items]="persons" [(ngModel)]="selectedPersonId"
                                placeholder="Kalibrasyon Yapanı Seç" bindLabel="fullName" bindValue="id"
                                #person="ngModel" required>
                            </ng-select>
                            <div class="text-danger mt-1" *ngIf="person.invalid && person.touched">
                                Zorunlu Alan
                            </div>
                        </div>

                        <div class="col-xl-auto col-md-6 col-sm-12"><strong>Kal. Yeri</strong></div>
                        <div class="col-xl-1 col-md-6 col-sm-12">
                            <div class="custom-control custom-radio">
                                <input type="radio" id="customRadio1" name="customRadio" class="custom-control-input"
                                    [checked]="isPlace" (change)="onPlaceChange(true)" />
                                <label class="custom-control-label" for="customRadio1">Yerinde</label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input type="radio" id="customRadio2" name="customRadio" class="custom-control-input"
                                    [checked]="!isPlace" (change)="onPlaceChange(false)" />
                                <label class="custom-control-label" for="customRadio2">Laboratuvarda</label>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-1">
                        <div class="col-xl-auto col-md-6 col-sm-12"><strong>Kal. Adresi</strong></div>
                        <div class="col-xl-7 col-md-6 col-sm-12">
                            <input type="text" class="form-control" [(ngModel)]="calibrationAddress">
                        </div>

                        <div class="col-xl-auto col-md-6 col-sm-12" *ngIf="!isPlace">
                            <strong>Kabul Tarihi</strong>
                        </div>
                        <div class="col-xl-2 col-md-6 col-sm-12" *ngIf="!isPlace">
                            <ng2-flatpickr [config]="dateTimeStartOptions" [(ngModel)]="date2"></ng2-flatpickr>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-xl-6 col-md-12 col-sm-12 w-100">
            <h4 class="card-title">Referans Cihaz Bilgileri</h4>

            <div class="card shadow-none bg-transparent border-warning p-1">
                <label>Referans Cihazları Seç</label>
                <ng-select [items]="refereceDevices" (change)="onDeviceSelect($event)" [(ngModel)]="selectedDevice"
                    placeholder="Referans Cihaz Seç" bindLabel="seriNo" bindValue="id">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                        <div class="d-flex justify-content-between align-items-center">
                            <h6 class="mb-1">{{ item.deviceName }}</h6>
                            <span class="badge" [ngClass]="{
                                                        'badge-success': item.isCalibrationValid,
                                                        'badge-danger': !item.isCalibrationValid
                                                    }">
                                {{ item.isCalibrationValid ? 'Aktif' : 'Pasif' }}
                            </span>
                        </div>
                        <p class="text-muted mb-1">{{item.typeName}}</p>
                        <p class="card-subtitle text-muted">
                            {{ item.brandName }} / {{item.modelName}} - {{item.seriNo}}
                            <!-- {{item.typeName}} -->
                        </p>
                        <p class="text-muted">{{item.referenceMin}} {{item.referenceUnitType}} -
                            {{item.referenceMax}} {{item.referenceUnitType}}</p>
                    </ng-template>
                </ng-select>
                <div class="text-danger mt-1" *ngIf="!selectedDevices || selectedDevices.length === 0">
                    En az bir referans cihaz seçmelisiniz.
                </div>

                <div class="table-responsive mt-1">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th>Kod</th>
                                <th>Marka/Model</th>
                                <th>Serial No</th>
                                <th>Tür</th>
                                <th>#</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let device of selectedDevices">
                                <td>{{ device.code }}</td>
                                <td>{{ device.brandName }} / {{ device.modelName }}</td>
                                <td>{{ device.seriNo }}</td>
                                <td>{{ device.typeName }}</td>
                                <td>

                                    <button type="button" class="btn btn-icon btn-flat-danger" rippleEffect
                                        (click)="removeDevice(device)">
                                        <span [data-feather]="'trash'"></span></button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>


        <div class="col-xl-6 col-md-12 col-sm-12">
            <h4 class="card-title">Sertfika Bilgileri</h4>
            <div class="card shadow-none bg-transparent border-warning">
                <form [formGroup]="certificateForm" class="mt-2">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-xl-2 col-md-6 col-sm-12" *ngIf="false">
                                <div class="form-group">
                                    <label for="disabledInput">Sertfika No</label>
                                    <input type="text" class="form-control" id="readonlyInput" readonly="readonly"
                                        formControlName="certificateNo" [value]="certificateNumber" />
                                </div>
                            </div>
                            <div class="col-xl-2 col-md-6 col-sm-12">
                                <div class="form-group">
                                    <label for="responsiblePerson">Sertfika No</label>
                                    <ng-select [items]="certificateReservations" bindLabel="reservedCertificateNo"
                                        bindValue="id" (change)="onReservationSelect($event)"
                                        (clear)="resetCertificateNumber()" [placeholder]="certificateNumber">
                                        <ng-template ng-header-tmp>
                                            <div class="d-flex justify-content-center">
                                                <button type="button" class="btn btn-flat-success"
                                                    (click)="addReservation()">
                                                    <span data-feather="plus"></span>
                                                    Rezerve
                                                </button>
                                            </div>
                                        </ng-template>
                                    </ng-select>
                                </div>
                            </div>
                            <div class="col-xl-4 col-md-6 col-sm-12">
                                <div class="form-group">
                                    <label for="personId" class="d-flex align-items-center">
                                        Sertifika Onaylayacak
                                        <span class="text-danger ml-1" *ngIf="certificateForm.get('personId')?.invalid">
                                            Zorunlu
                                        </span>
                                    </label>
                                    <ng-select [items]="calCompanyPerson" formControlName="personId"
                                        placeholder="Sertfika Onaylayan Personel" bindLabel="fullName" bindValue="id">
                                    </ng-select>

                                </div>
                            </div>

                            <div class="col-xl-3 col-md-6 col-sm-12">
                                <div class="form-group mb-2">
                                    <label for="startDate">Yayımlanma Tarihi</label>
                                    <ng2-flatpickr [config]="dateTimeCertificateEndOptions" formControlName="issueDate"
                                        [setDate]="date3"></ng2-flatpickr>
                                </div>
                            </div>

                            <div class="col-xl-3 col-md-6 col-sm-12">
                                <div class="form-group mb-2">
                                    <label for="startDate">Geçerlilik Tarihi</label>
                                    <ng2-flatpickr [config]="dateTimeCertificateStartOptions"
                                        formControlName="expiryDate" [setDate]="date4"></ng2-flatpickr>
                                </div>
                            </div>

                            <div class="col-xl-6 col-md-6 col-sm-12">
                                <div class="form-group mb-2 custom-control custom-checkbox">
                                    <input type="checkbox" id="visualAndFunctional"
                                        formControlName="visualAndFunctional" class="custom-control-input">
                                    <label class="custom-control-label" for="visualAndFunctional">Cihaz
                                        Görsel ve Fonksiyonel Kontrolü</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

            </div>
        </div>

        <div class="row col-12 justify-content-between mb-1">

            <!-- SOL TARAF -->
            <div class="col-12 col-xl-6">
                <div class="row align-items-end">

                    <div class="col-xl-2 col-md-2 col-sm-12 mt-1">
                        <button type="button" class="btn btn-outline-info w-100"
                            [disabled]="!selectMeasurementId || selectedDevices.length < 1"
                            (click)="downloadSelectedFile()">
                            İndir
                        </button>
                    </div>

                    <div class="col-xl-4 col-md-4 col-sm-12">
                        <label>Ölçüm Dosyasını İndir</label>
                        <ng-select [items]="measurementResults" [(ngModel)]="selectMeasurementId"
                            placeholder="Ölçüm Sonucu" bindValue="id" bindLabel="fileName">
                        </ng-select>
                    </div>

                    <div class="col-xl-6 col-md-6 col-sm-12">
                        <label>Ölçüm Dosyasını Seç (Excel)
                            <span class="text-danger" *ngIf="!selectedFile">
                                Zorunlu
                            </span>
                        </label>
                        <div class="custom-file">
                            <input type="file" accept=".xlsx, .xls, .xlsm" (change)="onFileSelected2($event)"
                                class="custom-file-input" id="customFile" />
                            <label class="custom-file-label" for="customFile">
                                {{selectedFile == null ? 'Dosya Seç' : selectedFileName }}
                            </label>
                        </div>


                        <button *ngIf="pdfDoc" type="button" class="btn btn-sm btn-danger mt-2" (click)="clearFile()">
                            Dosyayı Sil
                        </button>
                    </div>

                </div>
            </div>

            <!-- SAĞ TARAF -->
            <div class="col-12 col-xl-6">
                <div class="d-flex justify-content-end align-items-end gap-2 h-100">

                    <button type="button" class="btn btn-outline-info mr-1" (click)="convert()" *ngIf="selectedFile">
                        <i data-feather="eye" class="mr-25"></i>
                        Gör
                    </button>


                    <button type="button" class="btn btn-danger mr-1" (click)="closeModal()">
                        İptal
                    </button>

                    <button type="button" class="btn btn-success"
                        [disabled]="isSaveDisabled() || isSaving || !selectedFile" (click)="saveData(true)">
                        Kaydet
                    </button>

                </div>
            </div>
        </div>
    </div>

    <div class="col-12" *ngIf="pdfUrl" style="height:800px;">
        <iframe *ngIf="pdfUrl" [src]="pdfUrl" width="100%" height="800px" style="border:1px solid #ccc"></iframe>
    </div>
</div>